import { defaultAxios } from "../../utils/api/axios";
import { importUrl } from "../../utils/constance";

export const getAxiosImportServer = async (url, params) => {
  try {
    const config = {
      // baseURL: importUrl,
      baseURL: "http://51.159.0.19:8001/api",
      url,
      method: "get",
      params,
    };

    const data = await defaultAxios(config);

    if (data) {
      return data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("getAxiosImportServer here", error);
    return false;
  }
};
